'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M209.7 302.3c-15.3-15.3-34.9-25.3-55.9-28.9C187 138.8 252.2 72.6 317.8 41.7c63-29.7 128.7-27.9 171.5-19c8.8 42.8 10.7 108.5-19 171.5c-30.9 65.6-97.1 130.8-231.8 164c-3.6-21-13.6-40.6-28.9-55.9zM240 375.6l0-1.2c51.4-12.5 93.6-29.6 128-49.8l0 94.5-128 64 0-107.5zM384 424l0-109.4C522.4 223.2 520.1 79 502.7 9.3C433-8.1 288.8-10.4 197.4 128L88 128l-4.9 0-2.2 4.4-72 144L3.1 288 16 288l120.4 0c23.2 0 45.5 9.2 61.9 25.7s25.7 38.7 25.7 61.9L224 496l0 12.9 11.6-5.8 144-72 4.4-2.2 0-4.9zM137.7 272l-1.2 0L28.9 272l64-128 94.5 0c-20.2 34.4-37.3 76.6-49.8 128zm17.5 186.7c-20.7 20.7-57.3 30.6-92.1 34.7c-16.9 2-32.4 2.5-43.6 2.6c-1.2 0-2.3 0-3.4 0c0-1.1 0-2.2 0-3.4c0-11.3 .6-26.7 2.6-43.6c4.1-34.8 14.1-71.5 34.7-92.2c28.1-28.1 73.8-28.1 101.9 0s28.1 73.8 0 101.9zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C-7.5 395 .5 511.5 .5 511.5s116.5 8 166-41.5zM408 144a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;